import { Box, Flex, Heading, Text, Img } from "@chakra-ui/react";
import { FC } from "react";

const NotFound: FC = () => {
  return (
    <Box h="120vh" overflowY="auto" color="gray.800">
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        bg="white"
        borderRadius="8px"
        h="calc(120vh - 128px)"
      >
        <Img src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif" />

        <Heading
          fontSize={["80px", "80px", "120px"]}
          top="190px"
          fontWeight="600"
          position="absolute"
          bgGradient="linear(40deg, #f9e900, #1d5840)"
          bgClip="text"
        >
          404
        </Heading>
        <Heading mb={8} fontWeight="400">
          Página não encontrada
        </Heading>
        <Text maxW="460px" textAlign="center">
          Não foi possível encontrar essa página! Ela pode ter sido deletada ou
          nunca existiu
        </Text>
      </Flex>
    </Box>
  );
};

export default NotFound;
